import { render, staticRenderFns } from "./enviobcra.vue?vue&type=template&id=f54e142c"
import script from "./enviobcra.vue?vue&type=script&lang=js"
export * from "./enviobcra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports